import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ReddyLayout from '../components/home/ReddyLayout';
import MatchRow from '../components/home/MatchRow';
import IconImg from '../components/home/IconImg';
import { SPORT_SECTIONS, EVT } from '../data/homeData';

/* Reddy-styled sport page (Cricket / Football / Tennis / …) — the homepage sport-table
   card as a full page inside ReddyLayout. URL slug → section key + display info.
   iconId matches homeData SPORTS ids (menu-{id}.png; live-server → IconImg falls back
   to the gold placeholder). cols = the 3 right-hand column headers. */
const SPORT_MAP = {
  cricket:        { key: 'cricket',      label: 'Cricket',      iconId: '4',     cols: ['BACK', 'LAY', ''] },
  soccer:         { key: 'football',     label: 'Football',     iconId: '1',     cols: ['1', 'X', '2'] },
  football:       { key: 'football',     label: 'Football',     iconId: '1',     cols: ['1', 'X', '2'] },
  tennis:         { key: 'tennis',       label: 'Tennis',       iconId: '2',     cols: ['BACK', 'LAY', ''] },
  'horse-racing': { key: 'horse-racing', label: 'Horse Racing', iconId: '7',     cols: ['BACK', 'LAY', ''] },
  kabaddi:        { key: 'kabaddi',      label: 'Kabaddi',      iconId: '99994', cols: ['BACK', 'LAY', ''] },
  election:          { key: 'election',          label: 'Politics',            iconId: '2378961',  cols: ['BACK', 'LAY', ''] },
  sportsbook:        { key: 'sportsbook',        label: 'Sports Book',         iconId: '99991',    cols: ['BACK', 'LAY', ''] },
  'greyhound-racing':{ key: 'greyhound-racing',  label: 'Greyhound Racing',    iconId: '4339',     cols: ['BACK', 'LAY', ''] },
  binary:            { key: 'binary',            label: 'Binary',              iconId: '99990',    cols: ['BACK', 'LAY', ''] },
  basketball:        { key: 'basketball',        label: 'Basketball',          iconId: '7522',     cols: ['BACK', 'LAY', ''] },
  baseball:          { key: 'baseball',          label: 'Baseball',            iconId: '7511',     cols: ['BACK', 'LAY', ''] },
  'table-tennis':    { key: 'table-tennis',      label: 'Table Tennis',        iconId: '20',       cols: ['BACK', 'LAY', ''] },
  volleyball:        { key: 'volleyball',        label: 'Volleyball',          iconId: '998917',   cols: ['BACK', 'LAY', ''] },
  'ice-hockey':      { key: 'ice-hockey',        label: 'Ice Hockey',          iconId: '7524',     cols: ['BACK', 'LAY', ''] },
  rugby:             { key: 'rugby',             label: 'Rugby',               iconId: '5',        cols: ['BACK', 'LAY', ''] },
  mma:               { key: 'mma',               label: 'Mixed Martial Arts',  iconId: '26420387', cols: ['BACK', 'LAY', ''] },
  darts:             { key: 'darts',             label: 'Darts',               iconId: '3503',     cols: ['BACK', 'LAY', ''] },
  futsal:            { key: 'futsal',            label: 'Futsal',              iconId: '29',       cols: ['BACK', 'LAY', ''] },
  esports:            { key: 'esports',            label: 'E-Soccer',            iconId: '99992',    cols: ['BACK', 'LAY', ''] },
  'australian-rules': { key: 'australian-rules',   label: 'Australian Rules',    iconId: '61420',    cols: ['BACK', 'LAY', ''] },
  'american-football':{ key: 'american-football',  label: 'American Football',   iconId: '6423',     cols: ['BACK', 'LAY', ''] },
  snooker:            { key: 'snooker',            label: 'Snooker',             iconId: '6',        cols: ['BACK', 'LAY', ''] },
  handball:           { key: 'handball',           label: 'Handball',            iconId: '7',        cols: ['BACK', 'LAY', ''] },
  gaelic:             { key: 'gaelic',             label: 'Gaelic Games',        iconId: '8',        cols: ['BACK', 'LAY', ''] },
};

const FILTERS = ['LIVE', 'VIRTUAL', 'PREMIUM'];

export default function ReddySportPage() {
  const { sport } = useParams();
  const config = SPORT_MAP[sport] || { key: sport, label: sport, iconId: '0', cols: ['BACK', 'LAY', ''] };

  /* filter pills are visual-only (same as the homepage sport sections) — they toggle
     the crimson :checked state but don't filter the rows */
  const [activeFilters, setActiveFilters] = useState([]);
  const toggleFilter = (f) =>
    setActiveFilters((prev) => (prev.includes(f) ? prev.filter((x) => x !== f) : [...prev, f]));

  const section = SPORT_SECTIONS.find((s) => s.key === config.key);
  const rows = section ? section.rows : [];

  return (
    <ReddyLayout>
      <section className="section listing_page">
        <div className="row">
          <div className="col-lg-12 listing_page_12">
            <div className="middle-page-content home-page">
              <div className="card-body card-content p-0">
                {/* header: sport title + filter pills + 3 column headers */}
                <div className="bet-table-header">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <span className="list-sport-title">
                        <IconImg className="img-fluid game-icon-img" src={`${EVT}/menu-${config.iconId}.png`} alt={config.label} />
                        {` ${config.label}`}
                      </span>
                      {/* ks-cboxtags: LIVE / VIRTUAL / PREMIUM (the "+" comes from the CSS :before) */}
                      <ul className="ks-cboxtags">
                        {FILTERS.map((f, i) => {
                          const id = `filter-${sport}-${i}`;
                          return (
                            <li key={f}>
                              <input type="checkbox" id={id} checked={activeFilters.includes(f)} onChange={() => toggleFilter(f)} />
                              <label htmlFor={id}>{f}</label>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    {config.cols.map((c, i) => (
                      <div key={i} className="col-md-2 text-center d-none d-md-block"><small>{c}</small></div>
                    ))}
                  </div>
                </div>

                {/* match rows (reuse the homepage MatchRow) */}
                <div className="bet-table-body">
                  {rows.length > 0
                    ? rows.map((row, i) => <MatchRow key={i} row={row} />)
                    : <div className="text-center p-4" style={{ color: '#888' }}>No {config.label} matches available</div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ReddyLayout>
  );
}
